import { useCallback, useState } from 'react'

import { CarouselApi } from '../type'

export const useScroll = (api?: CarouselApi) => {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([])

  const [canScrollPrev, setCanScrollPrev] = useState(false)
  const [canScrollNext, setCanScrollNext] = useState(false)

  const handleInit = useCallback((api: CarouselApi) => {
    setScrollSnaps(api?.scrollSnapList() ?? [])
  }, [])

  const handleSelect = useCallback((api: CarouselApi) => {
    if (!api) return

    setCanScrollPrev(api.canScrollPrev())
    setCanScrollNext(api.canScrollNext())
    setSelectedIndex(api?.selectedScrollSnap() ?? 0)
  }, [])

  const scrollPrev = useCallback(() => {
    api?.scrollPrev()
  }, [api])

  const scrollNext = useCallback(() => {
    api?.scrollNext()
  }, [api])

  const scrollTo = useCallback(
    (index: number) => {
      api?.scrollTo(index)
    },
    [api],
  )

  return {
    selectedIndex,
    scrollSnaps,
    canScrollPrev,
    canScrollNext,
    handleInit,
    handleSelect,
    scrollPrev,
    scrollNext,
    scrollTo,
  }
}
